module.exports = __webpack_public_path__ + "static/img/6.aaf534c9.png";